module.exports = __webpack_public_path__ + "img/2b.297c3c98.jpg";